import {
  Badge,
  CircularProgress, // <-- Add this import
  IconButton,
  IconButtonProps,
  SvgIcon,
  SxProps,
  Tooltip,
} from '@mui/material';
import { getColor } from '../../../assets/theme';
import { SvgIconComponent } from '@mui/icons-material';
import { forwardRef } from 'react';

// Define the component props
export interface FormSidebarBtnInterface extends IconButtonProps {
  icon: SvgIconComponent;
  title: string;
  isActive?: boolean;
  sxIcon?: SxProps;
  badge?: number;
  loading?: boolean; // <-- Add loading prop
}

// Forward ref and manually type the props and ref
const FOFormSidebarBtn = forwardRef<HTMLButtonElement, FormSidebarBtnInterface>(
  (
    { icon, title, isActive = false, sxIcon, loading = false, ...props },
    ref,
  ) => {
    const { primary, gray } = getColor();

    return (
      <Tooltip title={title} placement='left' arrow>
        <span>
          <IconButton
            {...props}
            ref={ref}
            sx={{
              bgcolor: isActive ? '#2B349314' : '',
              width: '48px',
              height: '48px',
              borderRadius: '4px',
              ':hover': {
                bgcolor: '#2b349328',
              },
              position: 'relative',
              ...(props?.sx && { ...props.sx }),
            }}
            disabled={props.disabled || loading} // Disable when loading
          >
            {loading ? (
              <CircularProgress size={24} />
            ) : props.badge ? (
              <Badge badgeContent={props.badge} color='error' variant='dot'>
                <SvgIcon
                  component={icon}
                  sx={{
                    color: props?.disabled ? gray : primary,
                    fontSize: '24px',
                    ...(sxIcon && { ...sxIcon }),
                  }}
                />
              </Badge>
            ) : (
              <SvgIcon
                component={icon}
                sx={{
                  color: props?.disabled ? gray : primary,
                  fontSize: '24px',
                  ...(sxIcon && { ...sxIcon }),
                }}
              />
            )}
          </IconButton>
        </span>
      </Tooltip>
    );
  },
);

export default FOFormSidebarBtn;
